module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('page-outline', {
    attrs: {
      "title": _vm.$t('suppliers.kyc_form._label')
    }
  }, [_c('template', {
    slot: "titleContent"
  }, [_c('span', [_vm._v(_vm._s(_vm.$t('suppliers.kyc_form._label')))]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.cmpny') + ' : ' +
    _vm.currentSupplier.SocialReason) + "\n    ")]), _vm._v(" "), _c('span', {
    staticStyle: {
      "margin-left": "40px"
    }
  }, [_vm._v("\n      " + _vm._s(_vm.$t('common.rprsnttv') + ' : ' +
    _vm.currentSupplier.LegalRepresentativeFirstname +
    ' ' +
    _vm.currentSupplier.LegalRepresentativeLastname) + "\n    ")])]), _vm._v(" "), _c('template', {
    slot: "pageContent"
  }, [_c('div', {
    key: _vm.refreshPageContent
  }, [_c('vue-tabs', {
    attrs: {
      "active-tab-color": "var(--actionButtonColor)",
      "active-text-color": "var(--actionTextColor)"
    },
    model: {
      value: (_vm.tabName),
      callback: function($$v) {
        _vm.tabName = $$v
      },
      expression: "tabName"
    }
  }, _vm._l((_vm.workflow.steps), function(step, indexStep) {
    return _c('v-tab', {
      key: indexStep,
      attrs: {
        "title": step.step_label
      }
    }, [_c('div', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v("\n            " + _vm._s(_vm.$t('suppliers.kyc_form.' + step.step_label + '._label')) + "\n            "), (step.status === 101) ? _c('span', {
      staticClass: "dot",
      style: ('background-color:' + _vm.getStatusColor(step.status))
    }) : (step.status === 102) ? _c('span', {
      staticClass: "dot",
      style: ('background-color:' + _vm.getStatusColor(step.status))
    }) : (step.status === 103) ? _c('span', {
      staticClass: "dot",
      style: ('background-color:' + _vm.getStatusColor(step.status))
    }) : (step.status === 104) ? _c('f7-icon', {
      staticClass: "iconTab",
      style: ('color:' + _vm.getStatusColor(step.status)),
      attrs: {
        "fa": "check"
      }
    }) : (step.status === 105) ? _c('f7-icon', {
      staticClass: "iconTab",
      style: ('color:' + _vm.getStatusColor(step.status)),
      attrs: {
        "fa": "times"
      }
    }) : (step.status === 106) ? _c('f7-icon', {
      staticClass: "iconTab",
      style: ('color:' + _vm.getStatusColor(step.status)),
      attrs: {
        "fa": "times"
      }
    }) : _vm._e()], 1), _vm._v(" "), _c('supplier-kyc-form-step', {
      staticStyle: {
        "margin-top": "30px"
      },
      attrs: {
        "step": step,
        "seller": _vm.currentSupplier
      }
    })], 1)
  }), 1)], 1)])], 2)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4240681b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4240681b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/requests/detailPages/supplierDetailPages/SupplierKYCForm.vue
// module id = 2401
// module chunks = 2